import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface ServiceProviderCapabilitiesState {
  uniqueKeys: string[] | null;
}

const initialState: ServiceProviderCapabilitiesState = {
  uniqueKeys: null,
};

const serviceProviderCapabilitiesSlice = createSlice({
  name: "serviceProviderCapabilities",
  initialState,
  reducers: {
    setServiceProviderCapabilities: (
      state,
      action: PayloadAction<{ capabilities?: string[] }>,
    ) => {
      state.uniqueKeys = action.payload.capabilities ?? null;
    },
    clearServiceProviderCapabilities: (state) => {
      state.uniqueKeys = null;
    },
  },
});

export const {
  setServiceProviderCapabilities,
  clearServiceProviderCapabilities,
} = serviceProviderCapabilitiesSlice.actions;
export default serviceProviderCapabilitiesSlice.reducer;

export const selectServiceProviderCapabilities = (state: RootState) =>
  state.serviceProviderCapabilities.uniqueKeys;
